export default {
	fields:      {
		annual_property_value_appreciation: '',
		appraisal_value:                    '',
		back_end_debt_ratio:                '',
		beat_roi_of:                        '',
		car_note_monthly_payment:           '',
		cash_on_cash_return_gt:             '',
		cash_out_refi_ltv:                  '',
		cash_reserves_coef:                 '',
		credit_card_payments:               '',
		// desired_rental_market:              '',
		first_home_month_mortgage_payment:  '',
		front_end_debt_ratio:               '',
		gap_rate_gt:                        '',
		home_depreciation:                  '',
		id:                                 '',
		interest_expense_max_deduction:     '',
		monthly_rents_price_gt:             '',
		operating_expense_growth:           '',
		opex_tax_ins_monthly_rents_lt:      '',
		other_debt_monthly_payment:         '',
		rent_revenue_adjustment_by_banks:   '',
		rent_revenue_growth:                '',
		reserve_requirement:                '',
		student_loans_monthly_payment:      '',
		tax_bracket:                        '',
		your_credit_score:                  '',
		your_current_annual_salary:         '',
		your_current_rent:                  '',
		your_current_savings:               '',
		stock_market_growth:                '',
	},
	errors:      {}
};
